import './login.css';
import { useRef, useState } from 'react'
import { withAITracking } from '@microsoft/applicationinsights-react-js';
import { reactPlugin } from "../../Services/AppInsightService";
import { IAppUser } from "../../models/IAppUser";
import LoginForm from './LoginForm/LoginForm';

const AVATAR_ICONS = [
    "/images/Avatars/AvatarM01.png",
    "/images/Avatars/AvatarM02.png",
    "/images/Avatars/AvatarF01.png",
    "/images/Avatars/AvatarF02.png",
] as const;

interface ILoginProps {
    user: IAppUser;
    userAuthenticated: boolean
    loginCallback: (user: IAppUser) => void;
    logoutCallback: () => void;
}

const Login: React.FC<ILoginProps> = ({ user, userAuthenticated, loginCallback, logoutCallback }) => {
    const [isOpen, setIsOpen] = useState(false);
    const buttonRef = useRef<HTMLButtonElement>(null);
    const formDivRef = useRef<HTMLDivElement>(null);

    const GetRandomAvatar = () => {
        let num: number = 0;
        let imgSrc = "Avatar";
    
        const randomNumberInRange = (min: number, max: number) => {
            return Math.floor(Math.random() * (max - min + 1)) + min;
        };
        num = randomNumberInRange(1, 2);
        if (num === 1) {
            imgSrc += "M0";
        } else {
            imgSrc += "F0";
        }
        num = randomNumberInRange(1, 2);
        imgSrc += num;
    
        if (AVATAR_ICONS[0].includes(imgSrc)) {
            imgSrc = AVATAR_ICONS[0];
        } else if (AVATAR_ICONS[1].includes(imgSrc)) {
            imgSrc = AVATAR_ICONS[1];
        } else if (AVATAR_ICONS[2].includes(imgSrc)) {
            imgSrc = AVATAR_ICONS[2];
        } else if (AVATAR_ICONS[3].includes(imgSrc)) {
            imgSrc = AVATAR_ICONS[3];
        }
    
        return imgSrc;
    };

    const toggleDiv = () => {
        setIsOpen(!isOpen);
    };

    // useEffect(() => {
    //     // Watch for clicks outside of the button or it's div element
    //     const handleClickOutside = (event: any) => {
    //         if (isOpen && !buttonRef.current?.contains(event.target) && !formDivRef.current?.contains(event.target)) {
    //             setIsOpen(false);
    //         }
    //     };
    //
    //     document.addEventListener('mousedown', handleClickOutside);
    //     return () => {
    //       document.removeEventListener('mousedown', handleClickOutside);
    //     };
    // }, [isOpen]);


    return (
        <div className='login-control'>
            <button className="login-button" ref={buttonRef} onClick={toggleDiv}>
                <div className='login-button-text'>
                    {(!user.Name || !userAuthenticated) ? "Login" : user.Name}
                </div>
                <div className='login-button-image'>
                    <img alt={(!user.Name || !userAuthenticated) ? "Avatar" : user.Name} src={GetRandomAvatar()} width="27" height="27" className="login-button-avatar" />
                </div>
            </button>
            {isOpen && (
                <div ref={formDivRef} className='login-form-div'>
                    <LoginForm user={ user } userAuthenticated={ userAuthenticated } loginCallback={ (ret: IAppUser) => loginCallback(ret) } logoutCallback={ () => logoutCallback()} />
                </div>
            )}
        </div>
    );
}

export default withAITracking(reactPlugin, Login);
